const shifts = {
  toast: {
    error: {
      badResponse: '[תעריף] תגובת שרת שגויה',
    },
  },

  create: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן ליצור משמרת',
    },
    successToast: {
      message: 'הצלחה! המשמרת נוצרה בהצלחה',
    },
  },

  delete: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן למחוק משמרת',
    },
    successToast: {
      message: 'הצלחה! המשמרות נמחקו בהצלחה.',
    },
    confirmation: {
      header: 'אישור מחיקת משמרות',
      body: {
        dynamic: 'אתה עומד למחוק {{numShifts}} משמרות.',
        all: 'אתה עומד למחוק את כל המשמרות.',
      },
    },
  },

  edit: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן לעדכן משמרת',
    },
    successToast: {
      message: 'הצלחה! המשמרת עודכנה בהצלחה',
    },
  },

  headerButtons: {
    create: 'הוסף',
  },

  table: {
    headers: {
      name: 'שם',
      status: 'סטטוס',
      start: 'התחלה',
      end: 'סיום',
      year: 'שנה',
      direction: 'כיוון',
      weekDays: 'ימי השבוע',
    },
    cells: {
      direction: {
        collect: 'איסוף',
        distribute: 'פיזור',
        both: 'איסוף & פיזור',
      },
      weekDays: {
        weekDaysOptions: ['א\'', 'ב\'', 'ג\'', 'ד\'', 'ה\'', 'ו\'', 'ש\''],
      },
      status: {
        statusOptions: {
          statusActive: 'פעיל',
          statusNotActive: 'לא פעיל',
        },
      },
    },

    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  form: {
    header: {
      createShift: {
        title: 'הוסף',
      },

      updateShift: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      details: {
        header: 'משמרת',
        fields: {
          name: 'שם',
          status: 'סטטוס',
          start: 'התחלה',
          end: 'סיום',
          year: 'שנה',
          direction: 'כיוון',
          weekDays: 'ימי השבוע',
        },
      },
      directionOptions: {
        selectDirection: 'בחר כיוון',
        collect: 'איסוף',
        distribute: 'פיזור',
        both: 'איסוף & פיזור',
      },
    },
    validations: {
      name: {
        required: 'שם נדרש',
        name: '',
      },
      start: {
        required: 'שעת התחלה נדרשת',
        start: '',
      },
      end: {
        required: 'שעת סיום נדרשת',
        end: '',
      },
      year: {
        required: 'שנה נדרשת',
        year: '',
      },
      direction: {
        required: 'כיוון נדרש',
        direction: '',
      },
      weekDays: {
        required: 'עליך לבחור לפחות יום אחד',
        weekDays: '',
      },
    },
    notification: {
      overnight: 'שעת הסיום היא לפני שעת ההתחלה, כלומר האיסוף יתקיים ביום למחרת',
    },
  },
};

export default shifts;
